type CampaignPlanDisplayNameParams = {
  advertiserName: string;
  brandName: string;
};

export const getCampaignPlanDisplayName = ({ advertiserName, brandName }: CampaignPlanDisplayNameParams): string =>
  `${advertiserName.trim()} - ${brandName.trim()}`;
